export default "__VITE_ASSET__D7YRRNW3__"